import { CellContext } from '@tanstack/react-table';

import {
  getEnvironmentTypeIcon,
  getPlatformTypeName,
  isD2KSwarm,
} from '@/react/portainer/environments/utils';
import {
  EnvironmentType,
  ContainerEngine,
} from '@/react/portainer/environments/types';

import { Icon } from '@@/Icon';

import { EnvironmentListItem } from '../types';

import { columnHelper } from './helper';

type TypeCellContext = {
  type: EnvironmentType;
  containerEngine?: ContainerEngine;
  swarm: boolean;
};

export const type = columnHelper.accessor(
  (rowItem): TypeCellContext => ({
    type: rowItem.Type,
    containerEngine: rowItem.ContainerEngine,
    swarm: isD2KSwarm(rowItem),
  }),
  {
    header: 'Type',
    cell: Cell,
    id: 'Type',
  }
);

function Cell({ getValue }: CellContext<EnvironmentListItem, TypeCellContext>) {
  const { type, containerEngine, swarm } = getValue();

  return (
    <span className="flex items-center gap-1">
      <Icon icon={getEnvironmentTypeIcon(type, containerEngine, swarm)} />
      {getPlatformTypeName(type, containerEngine)}
    </span>
  );
}
